import { theme } from "../../../../theme";
import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
    wrap: {
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
    },
    input: {
        marginHorizontal: 1,
        textAlign: "center",
        borderRadius: theme.spacing.small,
    },
    inputSmall: {
        ...theme.fontDefaults.small,
        width: theme.spacing.large,
        height: theme.spacing.medium,
    },
    inputLarge: {
        ...theme.fontDefaults.base,
        width: theme.spacing.xlarge,
        height: theme.spacing.large,
    },
    button: {
        paddingVertical: 2,
        borderRadius: 100,
        overflow: "hidden",
        backgroundColor: theme.colors.usp.base,
        alignItems: "center",
        justifyContent: "center",
    },
    buttonSmall: {
        width: theme.spacing.medium,
        height: theme.spacing.medium,
    },
    buttonLarge: {
        width: theme.spacing.xlarge,
        height: theme.spacing.xlarge,
    },
    disabledButton: {
        backgroundColor: theme.colors.usp.lighter,
    },
    buttonTextSmall: {
        ...theme.fontDefaults.small,
        color: theme.colors.light.base,
    },
    buttonTextLarge: {
        ...theme.fontDefaults.xlarge,
        color: theme.colors.light.base,
    },
});
//# sourceMappingURL=InputQuantity.styles.js.map